export default __webpack_public_path__ + "static/media/img_frontend.e3d411ba.jpg";